import { useScrollEndReached } from '@/hooks/useScrollEndReached';
import { cn } from '@/lib/utils';

interface ScrollEndFadeProps {
    container: HTMLElement | null;
    contentVersions?: unknown[];
    className?: string;
}

export function ScrollEndFade({
    container,
    contentVersions = [],
    className,
}: ScrollEndFadeProps) {
    const endReached = useScrollEndReached(container, ...contentVersions);

    if (endReached) return null;

    return (
        <div
            aria-hidden
            className={cn(
                'pointer-events-none absolute inset-x-0 bottom-0 h-[42px] bg-[linear-gradient(180deg,rgba(27,28,30,0),var(--grey-600)_83%)]',
                className,
            )}
        />
    );
}
